import React from "react";
import { TopHeader } from "components/headers"; // Ensure the path is correct
import { MainFooter, SubFooter } from "components/footers"; // Ensure the path is correct

function Microsite() {
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
  };

  const iframeStyle = {
    flex: 1,
    width: "100%",
    border: "none",
  };

  return (
    <div style={containerStyle}>
      <header>
        <TopHeader />
      </header>
      <iframe
        src="rize/Home__Rize.html"
        title="test"
        style={iframeStyle}
      ></iframe>
      <footer>
        <MainFooter />
        <SubFooter />
      </footer>
    </div>
  );
}

export default Microsite;
